module.exports = __webpack_public_path__ + "static/media/person-accent-light.9f6baf9b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/person-accent-light.svg
// module id = 700
// module chunks = 0